// extracted by mini-css-extract-plugin
module.exports = {"root":"Entity_root__1Gv7R","date":"Entity_date__3sSW1"};